import React from 'react';
const contractors = ['Roofing', 'Landscaping', 'Tree Service', 'Construcción', 'Pressure Washing', 'Junk Removal', 'HVAC', 'Plomería'];
export function SocialProofBar() {
  return <div className="bg-dark-100 border-y border-white/5 py-6 overflow-hidden" data-id="element-395">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-396">
        <p className="text-center text-xs font-bold tracking-widest text-gray-500 uppercase mb-4" data-id="element-397">
          TRABAJAMOS CON CONTRACTORS DE:
        </p>
        <div className="flex flex-wrap justify-center items-center gap-x-8 gap-y-4" data-id="element-398">
          {contractors.map((type, index) => <div key={index} className="flex items-center" data-id="element-399">
              <span className="text-gray-300 font-medium" data-id="element-400">{type}</span>
              {index < contractors.length - 1 && <span className="hidden md:inline-block ml-8 text-gold/30" data-id="element-401">
                  •
                </span>}
            </div>)}
        </div>
      </div>
    </div>;
}